module.exports = __webpack_public_path__ + "img/icn_phone.9ecd8ce9.svg";